import { createRoot } from 'react-dom/client'
import './ds/styles/tokens.css'
import './ds/styles/gryd.css'
import './app.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(<App />)
